import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const WorkflowExecutionInfo_ = z.object({
  workflowId: z.string(),
  runId: z.string(),
  status: createEnum(["running", "completed", "failed", "canceled"]),
  startTime: z.string().optional(),
  closeTime: z.string().optional(),
  executionTime: z.string().optional(),
  historyLength: z.number().optional(),
});

export const getKlaviyoProfilesImportProgress = {
  name: "getKlaviyoProfilesImportProgress" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    currentWorkflow: WorkflowExecutionInfo_.optional(),
    allWorkflows: z.array(WorkflowExecutionInfo_),
    hasActiveImport: z.boolean(),
  }),
};
